module.exports = __webpack_public_path__ + "static/media/heihei.ac840290.png";